import React, { useState, useEffect, useRef } from 'react';

import MyPanel from '../../MyPanel';
import News from './News';
import './index.scss';

interface MediaCoverageSectionProps {
  textContent: any;
}

const FEATURED_OUTLETS = ['Nature', 'Science'];

const MediaCoverageSection: React.FC<MediaCoverageSectionProps> = (props) => {
  const { textContent } = props;
  const [activeTab, setActiveTab] = useState<'featured' | 'all'>('featured');

  const allItems: any[] = textContent.mediaCoveragePage;
  const displayedItems = activeTab === 'featured'
    ? allItems.filter((item: any) => FEATURED_OUTLETS.includes(item.mediaName))
    : allItems;
  const imageElementList: JSX.Element[] = displayedItems.map((item: any, textIdx: number) => <News key={textIdx} item={item} textIdx={textIdx} />);


  // art: 再加：点击照片以后，出现作品创作简介。有些是对社会的观察。有些是朋友猫猫的去世。中英文。
  // 4. Data Art Page (https://isamatov.com/react-grid-layout-tutorial/)
  // scroll
  const galleryRef = useRef(null)
  useEffect(() => {
    const handleScroll = (event: React.WheelEvent) => {
      if (galleryRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = galleryRef.current;
        const atEnd = scrollLeft + clientWidth >= scrollWidth;
        const atStart = scrollLeft <= 0;

        if (event.deltaY > 0 && !atEnd) {
          // Scrolling right
          event.preventDefault();
          // @ts-ignore
          galleryRef.current.scrollLeft += Math.abs(event.deltaY);
        } else if (event.deltaY < 0 && !atStart) {
          // Scrolling left
          event.preventDefault();
          // @ts-ignore
          galleryRef.current.scrollLeft -= Math.abs(event.deltaY);
        }
        // Allow vertical scrolling if at the start or end
      }
    };

    const galleryElement = galleryRef.current;
    if (galleryElement) {
      // @ts-ignore
      galleryElement.addEventListener('wheel', handleScroll, { passive: false });
    }

    // Cleanup the event listener on unmount
    return () => {
      if (galleryElement) {
        // @ts-ignore
        galleryElement.removeEventListener('wheel', handleScroll);
      }
    };
  }, []);

  return (
    <div className='media-coverage-div' id='mediaCoveragePage' style={{width: '100%'}}>
      <MyPanel viewTitle="MEDIA COVERAGE" width={'100%'} height={'auto'} panelHeaderHeight={72}>
        <div className='media-coverage-tabs'>
          <button
            className={`media-tab-btn${activeTab === 'featured' ? ' active' : ''}`}
            onClick={() => setActiveTab('featured')}
          >
            Featured
          </button>
          <button
            className={`media-tab-btn${activeTab === 'all' ? ' active' : ''}`}
            onClick={() => setActiveTab('all')}
          >
            All News
          </button>
        </div>
        <div className='media-coverage-parent-div'
          ref={galleryRef}
        >
          {imageElementList}
        </div>
      </MyPanel>
    </div>
  )
};

export default MediaCoverageSection;